// utils/icons.js

export const getIcon = (name, size = 100) => {
    const commonProps = {
      xmlns: "http://www.w3.org/2000/svg",
      width: size,
      height: size,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      viewBox:`0 0 100 100`
    };
 
    switch (name) {
      case "moves":
        return (
          <svg {...commonProps}>
{/*             <path d="M50,10 L60,20 L55,20 L55,45 L80,45 L80,40 L90,50 L80,60 L80,55 L55,55 L55,80 L60,80 L50,90 L40,80 L45,80 L45,55 L20,55 L20,60 L10,50 L20,40 L20,45 L45,45 L45,20 L40,20 Z"></path> */}
      <path fill="currentColor" d="M22.017 12.008L18.019 8.01l-.002 2.993h-5.001v-4.99l2.993.002l-4.002-4.002l-3.998 3.998l2.994.001v4.991h-5L6.002 8.01l-3.998 3.998l4.002 4.002l-.002-2.993h4.999v4.993l-2.994.001l3.998 3.999l4.002-4.002l-2.993.001v-4.992h5l-.001 2.993z"/>
       
          </svg>
        );
        
      case "move":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <line x1="12" y1="4" x2="12" y2="20" stroke="#94a3b8" strokeWidth="1.5"/>
            <line x1="4" y1="12" x2="20" y2="12" stroke="#94a3b8" strokeWidth="1.5"/>
            <polyline points="9,7 12,4 15,7" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <polyline points="9,17 12,20 15,17" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <polyline points="7,9 4,12 7,15" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <polyline points="17,9 20,12 17,15" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="12" cy="12" r="1.5" fill="#60a5fa"/>
          </svg>
        );
      case "rotate":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M20 12a8 8 0 1 1-2.35-5.65" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round"/>
            <polyline points="21,4 21,9 16,9" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="12" cy="12" r="1.5" fill="#60a5fa"/>
          </svg>
        );
      case "update":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24"><g fill="none" stroke="#888"  strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"><path d="M19.95 11a8 8 0 1 0-.5 4m.5 5v-5h-5"/><path d="M11 12a1 1 0 1 0 2 0a1 1 0 1 0-2 0"/></g></svg>
        );
      case "sitePlan":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 100 100">

 <path stroke="#fff" d="M35 35 L 35 65 L 65 65 L 65 35 Z" strokeWidth="2"/> 

  <line x1="20" y1="5" x2="12" y2="99" stroke="#fff" strokeWidth="2"/>
  <line x1="85" y1="5" x2="85" y2="99" stroke="#fff" strokeWidth="2"/>
  <line x1="4" y1="10" x2="95" y2="10" stroke="#fff" strokeWidth="2"/>
  <line x1="4" y1="90" x2="95" y2="85" stroke="#fff" strokeWidth="2"/>
</svg>
        );
      case "floorPlan":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 100 100">

<path stroke="#fff" d="M45 95 L 5 95 L 5 5 L 95 5 L 95 95 L60 95" strokeWidth="2"/>

  <line x1="60" y1="5" x2="60" y2="50" stroke="#fff" strokeWidth="2"/>
  <line x1="5" y1="50" x2="40" y2="50" stroke="#fff" strokeWidth="2"/>
  <line x1="40" y1="75" x2="40" y2="95" stroke="#fff" strokeWidth="2"/>
  <line x1="60" y1="75" x2="60" y2="95" stroke="#fff" strokeWidth="2"/>
</svg>
        );
      case "trim":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 512 512"><path fill="#888"   d="M103.48 224a71.64 71.64 0 0 0 44.76-15.66l41.5 16.89l6.82-12.63a39 39 0 0 1 4.32-6.37l14.22-14.42l-41.17-24.94A72 72 0 1 0 103.48 224m0-112a40 40 0 1 1-40 40a40 40 0 0 1 40-40"/><path  fill="#888"  d="m480 169l-5.52-12.58c-4.48-10.42-14.74-16-32.78-17.85c-10.12-1-26.95-1.24-49.69 3.81c-20 4.45-122.14 28.2-164.95 58.62c-20.25 14.39-24.06 33.67-27.06 49.16c-2.78 14.14-5 25.31-18 35c-15 11.14-27.27 16.38-33.58 18.6a71.74 71.74 0 1 0 24.79 38Zm-224.52 87a16 16 0 1 1 16-16a16 16 0 0 1-16 16m-152 144a40 40 0 1 1 40-40a40 40 0 0 1-40 40"/><path  fill="#888"  d="m343.79 259.87l-83.74 48.18l27.63 13.08l3.62 1.74C310 331.92 359.74 356 410.53 359c3.89.23 7.47.34 10.78.34C442 359.31 453 354 459.75 350L480 336Z"/></svg>
        );
      case "mirror":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24"><path stroke="#888" fill="#3472ff" d="M13 2v20h-2V2zM9 4.64V18.5H1.3zm6 0l7.7 13.86H15z"/></svg>
        );
      case "erase":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18" stroke="#e05555" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M6 6l12 12" stroke="#e05555" strokeWidth="1.5" strokeLinecap="round"/>
            <rect x="3" y="3" width="18" height="18" rx="3" stroke="#94a3b8" strokeWidth="1.5"/>
          </svg>
        );
      case "copy":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="3" y="3" width="11" height="11" rx="2" stroke="#94a3b8" strokeWidth="1.5" strokeDasharray="3 2"/>
            <rect x="10" y="10" width="11" height="11" rx="2" stroke="#94a3b8" strokeWidth="1.5"/>
            <circle cx="15.5" cy="15.5" r="1.5" fill="#60a5fa"/>
          </svg>
        );
      case "fillet":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 24 24"><g fill="none" stroke="#888" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"><path d="M2 20v-4C2 8.268 8.268 2 16 2h4m.839 18.84h-3.536m3.536 0v-3.536m0 3.535L18 18"/><path strokeDasharray="2 3" d="m9 9l7 7"/></g></svg>   
        );
      case "scale":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 48 48"><g fill="none" stroke="#888" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4"><path d="M30 6H42V18"/><path d="M31 29L19 29L19 17"/><path d="M42 6L19 29"/><path d="M22 6H8C6.89543 6 6 6.89543 6 8V40C6 41.1046 6.89543 42 8 42H40C41.1046 42 42 41.1046 42 40V26"/></g></svg>   
        );
    
      case "ofset":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 100 100"><path fill="#888" d="m96 70.895l-8.267 8.267L74.571 66L66 74.571l13.162 13.162L70.895 96H96Z"  /><path fill="#888"   d="M48.813 4c-.166 13.107-2.064 24.688-8.276 33.084S23.647 51.357 4 52.588l.438 6.986c20.918-1.31 34.117-8.044 41.726-18.328s9.475-23.45 9.648-37.158ZM74.78 6.123c-.068 3.29-.221 6.565-.513 9.813l4.98.447c.305-3.393.461-6.782.531-10.156zm-1.058 14.664c-.442 3.219-1.043 6.405-1.85 9.526l4.84 1.251c.862-3.334 1.499-6.712 1.963-10.097zM70.51 34.95a64 64 0 0 1-3.686 8.881l4.457 2.264a69 69 0 0 0 3.977-9.574zm-6.024 13.072c-1.678 2.741-3.543 5.349-5.629 7.737l3.766 3.289c2.3-2.634 4.325-5.471 6.127-8.414ZM55.56 59.213a58 58 0 0 1-7.446 6.021l2.819 4.131a63 63 0 0 0 8.088-6.543zm-11.52 8.584a71 71 0 0 1-8.672 4.24l1.895 4.627a76 76 0 0 0 9.279-4.539zm-13.213 5.94a88 88 0 0 1-9.361 2.605l1.078 4.883a93 93 0 0 0 9.895-2.756zM16.68 77.272c-3.208.541-6.443.926-9.694 1.168l.371 4.987c3.398-.254 6.788-.657 10.155-1.225z" /></svg>
        );
      case "update":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24"><g fill="none" stroke="#888"  strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"><path d="M19.95 11a8 8 0 1 0-.5 4m.5 5v-5h-5"/><path d="M11 12a1 1 0 1 0 2 0a1 1 0 1 0-2 0"/></g></svg>
          
        );
      case "line":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <line x1="5" y1="19" x2="19" y2="5" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round"/>
            <circle cx="5" cy="19" r="1.5" fill="#60a5fa"/>
            <circle cx="19" cy="5" r="1.5" fill="#60a5fa"/>
          </svg>
        );
      case "line2":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24"><path stroke="#888"    strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 18a2 2 0 1 0 4 0a2 2 0 1 0-4 0M16 6a2 2 0 1 0 4 0a2 2 0 1 0-4 0M7.5 16.5l9-9"/></svg>
        );
      case "polyline":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <polyline points="3,20 9,5 15,17 21,4" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="3" cy="20" r="1.5" fill="#60a5fa"/>
            <circle cx="9" cy="5" r="1.5" fill="#60a5fa"/>
            <circle cx="15" cy="17" r="1.5" fill="#60a5fa"/>
            <circle cx="21" cy="4" r="1.5" fill="#60a5fa"/>
          </svg>
        );
      case "circle":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="9" stroke="#94a3b8" strokeWidth="1.5"/>
            <line x1="12" y1="12" x2="19.5" y2="7.5" stroke="#60a5fa" strokeWidth="1" strokeDasharray="2 2"/>
            <circle cx="12" cy="12" r="1.5" fill="#60a5fa"/>
            <circle cx="19.5" cy="7.5" r="1.5" fill="#60a5fa"/>
          </svg>
        );
 
      case "arc":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M5 19 A12 12 0 0 1 19 5" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round"/>
            <circle cx="5" cy="19" r="1.5" fill="#60a5fa"/>
            <circle cx="19" cy="5" r="1.5" fill="#60a5fa"/>
            <circle cx="12" cy="8.5" r="1" fill="#60a5fa" opacity="0.6"/>
          </svg>
        );
      case "rect":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="4" y="6" width="16" height="12" stroke="#94a3b8" strokeWidth="1.5" strokeLinejoin="round"/>
            <circle cx="4" cy="6" r="1.5" fill="#60a5fa"/>
            <circle cx="20" cy="6" r="1.5" fill="#60a5fa"/>
            <circle cx="4" cy="18" r="1.5" fill="#60a5fa"/>
            <circle cx="20" cy="18" r="1.5" fill="#60a5fa"/>
          </svg>
        );
      case "spline":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M4 20 C4 8, 20 16, 20 4" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round"/>
            <circle cx="4" cy="20" r="1.5" fill="#60a5fa"/>
            <circle cx="20" cy="4" r="1.5" fill="#60a5fa"/>
          </svg>
        );
      case "ellipse":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <ellipse cx="12" cy="12" rx="9" ry="5.5" stroke="#94a3b8" strokeWidth="1.5"/>
            <line x1="3" y1="12" x2="21" y2="12" stroke="#60a5fa" strokeWidth="0.8" strokeDasharray="2 2"/>
            <circle cx="12" cy="12" r="1.5" fill="#60a5fa"/>
          </svg>
        );
      case "text":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <line x1="6" y1="5" x2="18" y2="5" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round"/>
            <line x1="12" y1="5" x2="12" y2="19" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round"/>
            <line x1="8" y1="19" x2="16" y2="19" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round"/>
            <circle cx="12" cy="5" r="1.5" fill="#60a5fa"/>
          </svg>
        );
      case "mtext":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <line x1="4" y1="7" x2="20" y2="7" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round"/>
            <line x1="4" y1="12" x2="16" y2="12" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round"/>
            <line x1="4" y1="17" x2="20" y2="17" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round"/>
            <circle cx="4" cy="7" r="1.5" fill="#60a5fa"/>
            <circle cx="4" cy="12" r="1.5" fill="#60a5fa"/>
          </svg>
        );      // Diğer ikonlar eklenebilir
      case "font":
        return (
<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24"><path fill="currentColor" d="M5 4h14v4h-1.5C17 6 17 5 15 5h-5v7h3c1 0 2-.5 2-2h1v5h-1c0-1.5-1-2-2-2h-3v4.5c0 2.5 3.5 2.5 3.5 2.5v1H5v-1c2-.5 2-1.5 2-2.5v-10c0-1 0-2-2-2.5z"/></svg>
);      // Diğer ikonlar eklenebilir
      case "fontSize":
        return (
<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24"><path fill="currentColor" d="m22 6l-3-4l-3 4h2v4h-2l3 4l3-4h-2V6zM9.307 4l-6 16h2.137l1.875-5h6.363l1.875 5h2.137l-6-16zm-1.239 9L10.5 6.515L12.932 13z"/></svg>
);      // Diğer ikonlar eklenebilir
      case "bold":
        return (
<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 16 16"><path fill="currentColor" d="M4 2h4.5a3.501 3.501 0 0 1 2.852 5.53A3.499 3.499 0 0 1 9.5 14H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m1 7v3h4.5a1.5 1.5 0 0 0 0-3Zm3.5-2a1.5 1.5 0 0 0 0-3H5v3Z"/></svg>
);      // Diğer ikonlar eklenebilir
      case "italic":
        return (
<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="2" d="M13.34 10c-.918 2.734-2.34 7-2.34 7m3.21-10h-.01"/></svg>
);      // Diğer ikonlar eklenebilir
      case "alignment":
        return (
<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 9a3 3 0 1 0 6 0a3 3 0 0 0-6 0M4 12V7a3 3 0 1 1 6 0v5M4 9h6m10-3v6M4 16h12M4 20h6m4 0l2 2l5-5"/></svg>
);      // Diğer ikonlar eklenebilir
        case "groundingStrip":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 100 100">
 
     <path fill="none" stroke="#888" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M10 90 L40 20 L80 20 L80 90"  />
   
 
          </svg>
        );
   
      case "groundingStake":
        return (
  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24">
    <path stroke="#888"    strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 4a2 2 0 1 0 4 0a2 2 0 1 0-4 0M12 6l0 8l-8 0l16 0 "/>
    <path stroke="#888"    strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18l12 0 "/>
    <path stroke="#888"    strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 22l6 0 "/>
    </svg>
);      // Diğer ikonlar eklenebilir
    
      case "box":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 100 100">
      
        <path fill="none" stroke="#888" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M5 5 L95 5 L95 95 L5 95 Z"  />
          <text x="50" y="50" fontSize="20" textAnchor="middle" fill="#888" dy=".3em">Box</text>
    
          </svg>
        );
      case "pole":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 100 100">
      
   
    <circle cx="50" cy="50" r="50" stroke="#3535FF" strokeWidth="4" fill="none"/>
      
          </svg>
        );
              case "supply":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 100 100">
  
     <path fill="none" stroke="#888" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M5 5 L95 5 L95 95 L5 95 Z"  />
   
   
          </svg>
        );
              case "priz":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 100 100"><g fill="none" stroke="#888" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
            <path d="M 25,10 A 25,26 0 0 0 75,10" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>

             <path fill="none" stroke="#888" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M25 42 L75 42 Z"  />
             <path fill="none" stroke="#888" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M50 42 L50 80 Z"  />
              </g></svg>
        );
      case "supplyBox":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="4" y="4" width="16" height="16" rx="2" stroke="#94a3b8" strokeWidth="1.5"/>
            <path d="M13.5 7l-3 5h4l-3 5" stroke="#60a5fa" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
          </svg>
        );
      case "socket":
        // Uygulamadaki priz (normal): dikey sap + yatay cubuk + ustte yarim daire (∪).
        // Kaynak: createSocketSymbols line1 (0->21), line2 (-7..7 @21),
        // arc (merkez (0,28) r7, alt yarim: (7,28)->(0,21)->(-7,28)).
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M7.5 3.5 A 4.5 4.5 0 0 0 16.5 3.5" stroke="#cbd5e1" strokeWidth="1.6" strokeLinecap="round" fill="none"/>
            <line x1="7.5" y1="8" x2="16.5" y2="8" stroke="#cbd5e1" strokeWidth="1.6" strokeLinecap="round"/>
            <line x1="12" y1="8" x2="12" y2="21" stroke="#cbd5e1" strokeWidth="1.6" strokeLinecap="round"/>
          </svg>
        );
      case "switchIcon":
        // Uygulamadaki anahtar (adi) sembolu: sap + daire + tepede saga bayrak.
        // Kaynak: createLightingSymbols line1 (0->15) + daire (merkez 21, r6)
        // + line2 (0,27)->(0,42)->(5,42).
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <line x1="12" y1="21" x2="12" y2="14.7" stroke="#cbd5e1" strokeWidth="1.6" strokeLinecap="round"/>
            <circle cx="12" cy="12" r="2.7" stroke="#cbd5e1" strokeWidth="1.4" fill="none"/>
            <polyline points="12,9.3 12,4 14.6,4" stroke="#cbd5e1" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
          </svg>
        );
      case "fixture":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="10" r="6" stroke="#94a3b8" strokeWidth="1.5"/>
            <line x1="8.2" y1="6.2" x2="15.8" y2="13.8" stroke="#94a3b8" strokeWidth="1"/>
            <line x1="15.8" y1="6.2" x2="8.2" y2="13.8" stroke="#94a3b8" strokeWidth="1"/>
            <line x1="12" y1="16" x2="12" y2="21" stroke="#60a5fa" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        );
      case "bellButton":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M12 3a1 1 0 0 1 1 1v1a5 5 0 0 1 4 4.9V14l2 2H5l2-2v-4.1A5 5 0 0 1 11 5V4a1 1 0 0 1 1-1z" stroke="#94a3b8" strokeWidth="1.5" fill="none" strokeLinejoin="round"/>
            <line x1="5" y1="16" x2="19" y2="16" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M10.5 19a1.5 1.5 0 0 0 3 0" stroke="#60a5fa" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
          </svg>
        );
      case "cableShaft":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="7" y="3" width="10" height="18" rx="1" stroke="#94a3b8" strokeWidth="1.5"/>
            <line x1="10" y1="6" x2="10" y2="18" stroke="#60a5fa" strokeWidth="1" strokeDasharray="2 2"/>
            <line x1="14" y1="6" x2="14" y2="18" stroke="#60a5fa" strokeWidth="1" strokeDasharray="2 2"/>
            <line x1="7" y1="9" x2="17" y2="9" stroke="#94a3b8" strokeWidth="1"/>
            <line x1="7" y1="15" x2="17" y2="15" stroke="#94a3b8" strokeWidth="1"/>
          </svg>
        );
      case "kolonSema":
        // Kolon şeması — dikey kolon hattı + katlara branşman + pano kutuları
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <line x1="6" y1="3" x2="6" y2="21" stroke="#94a3b8" strokeWidth="1.6" strokeLinecap="round"/>
            <line x1="6" y1="6" x2="15" y2="6" stroke="#94a3b8" strokeWidth="1.3"/>
            <line x1="6" y1="12" x2="15" y2="12" stroke="#94a3b8" strokeWidth="1.3"/>
            <line x1="6" y1="18" x2="15" y2="18" stroke="#94a3b8" strokeWidth="1.3"/>
            <rect x="15" y="4.5" width="4" height="3" stroke="#60a5fa" strokeWidth="1.2"/>
            <rect x="15" y="10.5" width="4" height="3" stroke="#60a5fa" strokeWidth="1.2"/>
            <rect x="15" y="16.5" width="4" height="3" stroke="#60a5fa" strokeWidth="1.2"/>
          </svg>
        );
      case "panoDetay":
        // Pano detay — dağıtım panosu + sigorta/kesici satırları
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="4" y="3" width="16" height="18" rx="1" stroke="#94a3b8" strokeWidth="1.5"/>
            <line x1="4" y1="8" x2="20" y2="8" stroke="#94a3b8" strokeWidth="1.2"/>
            <line x1="12" y1="8" x2="12" y2="21" stroke="#94a3b8" strokeWidth="1"/>
            <line x1="6.5" y1="11" x2="9.5" y2="11" stroke="#60a5fa" strokeWidth="1.3" strokeLinecap="round"/>
            <line x1="6.5" y1="14" x2="9.5" y2="14" stroke="#60a5fa" strokeWidth="1.3" strokeLinecap="round"/>
            <line x1="6.5" y1="17" x2="9.5" y2="17" stroke="#60a5fa" strokeWidth="1.3" strokeLinecap="round"/>
            <line x1="14.5" y1="11" x2="17.5" y2="11" stroke="#60a5fa" strokeWidth="1.3" strokeLinecap="round"/>
            <line x1="14.5" y1="14" x2="17.5" y2="14" stroke="#60a5fa" strokeWidth="1.3" strokeLinecap="round"/>
            <line x1="14.5" y1="17" x2="17.5" y2="17" stroke="#60a5fa" strokeWidth="1.3" strokeLinecap="round"/>
          </svg>
        );
      case "titleBlock":
        // Başlık — pafta + sağ-altta başlık bloğu ızgarası
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="3" y="4" width="18" height="16" rx="1" stroke="#94a3b8" strokeWidth="1.5"/>
            <rect x="11" y="13" width="9" height="6" stroke="#60a5fa" strokeWidth="1.2"/>
            <line x1="11" y1="16" x2="20" y2="16" stroke="#60a5fa" strokeWidth="1"/>
            <line x1="15.5" y1="13" x2="15.5" y2="19" stroke="#60a5fa" strokeWidth="1"/>
          </svg>
        );
      case "kabloRiser":
        // Kablo bacası — dikey baca + dalgalı kablolar
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="8" y="3" width="8" height="18" rx="1" stroke="#94a3b8" strokeWidth="1.5"/>
            <path d="M10.5 4 Q13 8 10.5 12 Q8 16 10.5 20" stroke="#60a5fa" strokeWidth="1.2" fill="none"/>
            <path d="M13.5 4 Q11 8 13.5 12 Q16 16 13.5 20" stroke="#60a5fa" strokeWidth="1.2" fill="none"/>
          </svg>
        );
      case "energyRoom":
        // Enerji Odası — oda + elektrik (şimşek) sembolü
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="3" y="4" width="18" height="16" rx="1" stroke="#94a3b8" strokeWidth="1.5"/>
            <path d="M13 7 L9 13 h2.5 l-1 4 4.5-6 h-2.5 z" fill="#60a5fa" stroke="#60a5fa" strokeWidth="0.6" strokeLinejoin="round"/>
          </svg>
        );
      case "projectCreate":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="4" y="2" width="12" height="16" rx="2" stroke="#94a3b8" strokeWidth="1.5"/>
            <line x1="8" y1="7" x2="12" y2="7" stroke="#94a3b8" strokeWidth="1" strokeLinecap="round"/>
            <line x1="8" y1="10" x2="14" y2="10" stroke="#94a3b8" strokeWidth="1" strokeLinecap="round"/>
            <line x1="8" y1="13" x2="11" y2="13" stroke="#94a3b8" strokeWidth="1" strokeLinecap="round"/>
            <circle cx="17" cy="17" r="5.5" fill="#1f1f2e" stroke="#60a5fa" strokeWidth="1.5"/>
            <line x1="17" y1="14.5" x2="17" y2="19.5" stroke="#60a5fa" strokeWidth="1.5" strokeLinecap="round"/>
            <line x1="14.5" y1="17" x2="19.5" y2="17" stroke="#60a5fa" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        );
      case "docUpdate":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            {/* Yuvarlak dairesel ok — refresh/güncelle */}
            <path d="M21 12a9 9 0 1 1-2.63-6.36" stroke="#94a3b8" strokeWidth="1.8" strokeLinecap="round" fill="none"/>
            <path d="M21 3v6h-6" stroke="#60a5fa" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
          </svg>
        );
      case "ortho":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <line x1="4" y1="20" x2="4" y2="4" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round"/>
            <line x1="4" y1="20" x2="20" y2="20" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round"/>
            <rect x="4" y="15" width="5" height="5" stroke="#60a5fa" strokeWidth="1.2" fill="none"/>
            <polyline points="4,8 8,8 8,4" stroke="#60a5fa" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" fill="none" strokeDasharray="2 2"/>
          </svg>
        );
      case "snap":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="8" stroke="#94a3b8" strokeWidth="1.5"/>
            <line x1="12" y1="2" x2="12" y2="6" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round"/>
            <line x1="12" y1="18" x2="12" y2="22" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round"/>
            <line x1="2" y1="12" x2="6" y2="12" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round"/>
            <line x1="18" y1="12" x2="22" y2="12" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round"/>
            <circle cx="12" cy="12" r="2" fill="#60a5fa"/>
          </svg>
        );
      case "grid":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <line x1="4" y1="4" x2="4" y2="20" stroke="#94a3b8" strokeWidth="1"/>
            <line x1="10" y1="4" x2="10" y2="20" stroke="#94a3b8" strokeWidth="1"/>
            <line x1="16" y1="4" x2="16" y2="20" stroke="#94a3b8" strokeWidth="1"/>
            <line x1="20" y1="4" x2="20" y2="20" stroke="#94a3b8" strokeWidth="1"/>
            <line x1="4" y1="4" x2="20" y2="4" stroke="#94a3b8" strokeWidth="1"/>
            <line x1="4" y1="10" x2="20" y2="10" stroke="#94a3b8" strokeWidth="1"/>
            <line x1="4" y1="16" x2="20" y2="16" stroke="#94a3b8" strokeWidth="1"/>
            <line x1="4" y1="20" x2="20" y2="20" stroke="#94a3b8" strokeWidth="1"/>
            <circle cx="10" cy="10" r="1.5" fill="#60a5fa"/>
          </svg>
        );
      case "locked":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="5" y="11" width="14" height="10" rx="2" stroke="#94a3b8" strokeWidth="1.5"/>
            <path d="M8 11V7a4 4 0 0 1 8 0v4" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
            <circle cx="12" cy="16" r="1.5" fill="#60a5fa"/>
          </svg>
        );
      case "unlocked":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="5" y="11" width="14" height="10" rx="2" stroke="#94a3b8" strokeWidth="1.5"/>
            <path d="M8 11V7a4 4 0 0 1 8 0" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
            <circle cx="12" cy="16" r="1.5" fill="#60a5fa"/>
          </svg>
        );
default:
        return null; // Belirtilmeyen ikon ismi için null döner
    }
  };
  